<script setup>
  import ListeProductions from '@/components/ListeProductions.vue'

</script>

<template>
  <h1>Avancement des productions de {{ nameClient }}</h1>
  <button class="back" @click="goBack"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
  </svg>Retour</button>
  <div class="prod">
    <ListeProductions/>
  </div>
</template>

<script>

import axios from '@/components/axiosConfig.js'



export default {
  data() {
    return {
      nameClient: '',
    };
  },
  mounted() {
    this.idClient = this.$route.params.idClient

    

    axios.post('https://www.simef.fr/espace-client/api/getUtilisateur.php', {
      id: this.idClient
    })
    .then(response => {
      this.nameClient = response.data.clientName;
    })
    .catch(error => {
      console.error(error);
      
    });

   
    
  }, 
  methods: {
    goBack() {
      const queryParams = {
        page: this.currentPage,
        searchTerm: this.searchTerm,
      };
      this.$router.go(-1);
      this.$router.push({ query: queryParams });
    },
  }
}
</script>

<style>


</style>
